import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { markPubnubAsDone } from '../actions';
// components
import SearchHeader from '../headers/searchHeader';
import AppointmentNavigator from './appointmentNavigator';
import {
  getIsLoading,
} from './appointmentSelector';
import withMinInterval from '../../common/hoc/withMinInterval';
import { containerApp } from '../../../main';
import { getBarbers } from '../barbers/actions';

class AppointmentsWrapper extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.pubnubChange) {
      this.props.markPubnubAsDone();
    }
  }

  render() {
    const {
      currentView,
      additionalButtons,
      isLoading,
      minInterval,
    } = this.props;

    let loading;
    if (isLoading) {
      loading = (
        <div className="o-flexbox__item c-loader" data-automation-id="appointments-page-loader">
          <div className="c-loader__spin" data-automation-id="icon:loading" />
        </div>
      );
    }
    return (
      <div
        className={classnames('c-appointments-view', {
          'five-min-interval': minInterval === 5,
        })}
      >
        <SearchHeader
          heading="Appointments"
          button="Add appointment"
          type="appointment"
          display-if={!containerApp.isActive()}
        />
        <div
          className={classnames('c-appointments-view__header', {
            'c-appointments-view__header_container-app': containerApp.isActive(),
          })}
        >
          <AppointmentNavigator
            currentView={currentView}
            additionalButtons={additionalButtons}
          />
        </div>
        <div className="c-appointments-view__body">
          <div className="c-wrapper o-page-height">
            { loading }
            { this.props.children }
          </div>
        </div>
      </div>
    );
  }
}

AppointmentsWrapper.propTypes = {
  markPubnubAsDone: PropTypes.func.isRequired,
  children: PropTypes.node,
  currentView: PropTypes.string.isRequired,
  additionalButtons: PropTypes.node,
  isLoading: PropTypes.bool.isRequired,
  minInterval: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  shop: state.auth.shop,
  pubnubChange: state.main.pubnub_change,
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  markPubnubAsDone,
  getBarbers,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.getBarbers(this.props.shop);
    },
  })
)(withMinInterval(AppointmentsWrapper));
